import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';

const SkillsContainer = styled(StyledFlexContainer)`
	width: 100%;
	margin-top: 3rem;
	flex-direction: row;

	@media screen and (max-width: 900px) {
		width: 100%;
		flex-direction: column;
	}
`;

export default SkillsContainer;
